import appStore from '../utils/state';
import isTailwindBreakpoint from '../utils/isTailwindBreakpoint';

export default class NewsletterButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;

  private desktopKlaviyoId: string | null = null;
  private mobileKlaviyoId: string | null = null;

  private onClickBound = this.onClick.bind(this);

  constructor() {
    super();
    this.desktopKlaviyoId = this.getAttribute('data-desktop-klaviyo-id');
    this.mobileKlaviyoId = this.getAttribute('data-mobile-klaviyo-id');
  }

  connectedCallback(): void {
    this.button = this.querySelector('[data-newsletter-button-ref="button"]');

    this.addEventListeners();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
  }

  onClick(): void {
    // @ts-ignore
    window._klOnsite = window._klOnsite || [];

    if (isTailwindBreakpoint('sm')) {
      // @ts-ignore
      window._klOnsite.push(['openForm', this.desktopKlaviyoId]);
    } else {
      // @ts-ignore
      window._klOnsite.push(['openForm', this.mobileKlaviyoId]);
    }
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('newsletter-button', NewsletterButton);
